import { useQuery } from "@tanstack/react-query"
import { getListTeachers } from "api/teacher.api.ts"
import { useCallback, useState } from "react"
import { useLocation } from "react-router-dom"
import styled from "styled-components"
import { LoaderComponent, PAGE_HEIGHT } from "ui/base/loading/LoaderComponent"
import { mediaSizes, pageContainerStyles } from "ui/theme"
import { getLowestValidPrice } from "utils"
import { ClassSection } from "./section/ClassSection"
import { MapSection } from "./section/MapSection"
import { OnlineSearchSection } from "./section/OnlineSearchSection"
import { SearchResultsTitle } from "./section/SearchResultsTitle"
import { TeacherNotFound } from "./TeacherNotFound"

const options = [
  { value: "popularity", label: "Popularity" },
  { value: "price", label: "Price" },
]

export const SearchOnline = () => {
  const { state } = useLocation()

  const [sortBy, setSortBy] = useState(options[0])

  const query = state?.typeOfClass?.label || ""
  const coordinates = state?.coordinates ? state.coordinates : {}
  const online_type = state?.online_type?.value || ""

  const { data, isLoading } = useQuery({
    queryKey: [
      "getListTeachers",
      query,
      coordinates,
      sortBy.value,
      online_type,
    ],
    queryFn: async () => {
      const response = await getListTeachers({
        query,
        online_type,
        ...coordinates,
        sort_by: sortBy.value,
      })

      let classes = response?.data || []

      if (sortBy.value === "popularity") {
        classes = classes.sort((a, b) => (Number(b.rate) || 0) - (Number(a.rate) || 0))
      }

      if (sortBy.value === "price") {
        classes = classes.sort((a, b) => {
          const priceA = getLowestValidPrice(
            a.type_of_class,
            a.price_per_group_class,
            a.price_per_private_class
          )
          const priceB = getLowestValidPrice(
            b.type_of_class,
            b.price_per_group_class,
            b.price_per_private_class
          )
          return priceA - priceB
        })
      }

      return classes
    },
  })

  const classes = data || []
  const handleSortChange = useCallback((option) => setSortBy(option), [])
  const isTeachersFound = !!classes.length

  if (isLoading)
    return <LoaderComponent minHeight={PAGE_HEIGHT}/>

  if (!isTeachersFound) return <TeacherNotFound />

  if (online_type === "offline") {
    return (
      <PageWrapper>
        <SearchResultsTitle
          query={query}
          count={classes?.length}
          hideOnDesktop
        />
        <MapSection
          query={query}
          nbrClasses={classes?.length}
          classes={classes}
        />
        <ClassSection
          query={query}
          classes={classes}
          sortBy={sortBy}
          onSortChange={handleSortChange}
          isLoading={isLoading}
          online_type={online_type}
        />
      </PageWrapper>
    )
  }

  return (
    <OnlineSearchSection
      query={query}
      classes={classes}
      sortBy={sortBy}
      onSortChange={handleSortChange}
      online_type={online_type}
    />
  )
}

const PageWrapper = styled.div`
  ${pageContainerStyles}
  font-family: Montserrat, sans-serif;
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;
  min-height: 80dvh;
  padding-top: 1rem;
  @media (width >= ${mediaSizes.md}) {
    height: var(--page-height);
    grid-template-columns: 2fr 3fr;    
    overflow: hidden;
    padding-bottom: 3rem;
  }

`

const SingleWrapper = styled.div`
  ${pageContainerStyles}
  font-family: Montserrat, sans-serif;
  min-height: 80dvh;
  @media (width >= ${mediaSizes.md}) {
    height: var(--page-height);
    grid-template-columns: 2fr 3fr;    
    overflow: hidden;
  }
`

